'use strict';
var parent = require('../../actual/url-search-params');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/url-search-params/index.js
// module id = 644
// module chunks = 13